import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import Dashboard from './Pages/Dashboard';
import { GithubProvider } from './hooks/useGithub';
import ProfilePage from './Pages/ProfilePage';
import WorkExperiences from './Pages/WorkExperiences/WorkExperiences';
import Repos from './Pages/Repos/Repos';
import ScreenWrapper from '../src/utils/ScreenWrapper';
import Md from '../src/Pages/Markdown/md';
import Pdf from './Pages/pdf/pdf';

function App() {
    const router = createBrowserRouter([
        {
            path: '/',
            element: <Dashboard />,
            children: [
                { path: '', element: <Navigate to="/overview/workexperience" replace /> },
                {
                    path: '/overview',
                    element: <ProfilePage sx={{ width: '100%' }} />,
                    children: [
                        { path: '', element: <Navigate to="/overview/workexperience" replace /> },
                        {
                            path: '/overview/workexperience',
                            element: <WorkExperiences />
                        },
                        {
                            path: '/overview/repositories',
                            element: <Repos />
                        }
                    ]
                },
                {
                    path: '/md/*',
                    element: <Md />
                },
                {
                    path: '/pdf/*',
                    element: <Pdf />
                }
            ]
        }
    ]);

    return (
        <GithubProvider username={'AaronAmelink'}>
            <ScreenWrapper>
                <RouterProvider router={router} />
            </ScreenWrapper>
        </GithubProvider>
    );
}

export default App;
